// Funções utilitárias de autenticação e cache

export const isLoggedInToday = () => {
  const logado = localStorage.getItem('logado') === 'S';
  const loginDate = localStorage.getItem('loginDate');
  const today = new Date().toISOString().split('T')[0];
  return logado && loginDate === today;
};

export const setLoginToday = (usuario, loja, sap, codigorest) => {
  const today = new Date().toISOString().split('T')[0];
  let chapaFormatada = String(usuario).padStart(6, '0');

  localStorage.setItem("logado", "S");
  localStorage.setItem("loginDate", today);
  localStorage.setItem("chapa", chapaFormatada);
  localStorage.setItem("loja", loja || "");
  localStorage.setItem("acessoSAP", sap || "N");
  localStorage.setItem("codigorest", codigorest || "");

  // Limpa cache e força reload total ao logar
  clearBrowserCache();
};

// Limpa cache de navegador
export const clearBrowserCache = () => {
  try {
    // Limpa cache, service workers, e recarrega
    if ('caches' in window) {
      caches.keys().then(names => {
        for (let name of names) caches.delete(name);
      });
    }
    if (window.performance && window.performance.clearResourceTimings) {
      window.performance.clearResourceTimings();
    }
    localStorage.removeItem('v'); // remove possível chave de versão
  } catch (e) {
    console.warn("Erro limpando cache:", e);
  }
};

// Logout completo
export const logout = () => {
  localStorage.clear();
  clearBrowserCache();
  setTimeout(() => {
    window.location.href = "/arbor/login";
  }, 300);
};
